{
    "TERMS_CONDITIONS_TITLE": "Términos y condiciones"
}